import { InjectionToken } from '@angular/core';
import { distinctUntilChanged, Observable, OperatorFunction, scan } from 'rxjs';
import { map } from 'rxjs/operators';

export const LOADING_STATE_HANDLER_SERVICE_TOKEN = new InjectionToken<LoadingStateHandlerService>(
  'LoadingStateHandlerService',
);

export type LoadingState = { [loadingStateId: string]: boolean };

export interface LoadingStateHandlerService {
  isReportLoading$: Observable<boolean>;
  setLoadingState(loadingStateId: string, isLoading: boolean): void;
}

export function mapLoadingReportState(initialState: LoadingState = {}): OperatorFunction<LoadingState, boolean> {
  return (input$): Observable<boolean> =>
    input$.pipe(
      scan((acc, newVal) => {
        return { ...acc, ...newVal };
      }, initialState),
      map((loadingState) => {
        try {
          return Object.values(loadingState).some((loading) => loading === true);
        } catch {
          return true;
        }
      }),
      distinctUntilChanged(),
    );
}
